<template>
<div class="ui row">
  <div class="ui three wide column">
    <Dashboard :course="course"
               :checkpoints="checkpoints"
               :languages="languages"
               :selectedLanguage="selectedLanguage"></Dashboard>
  </div>
  <div class="ui thirteen wide column">
    <ContentContainer :course="course"
                      :checkpoint="checkpoint"></ContentContainer>
  </div>
</div>
</template>

<script>
import Dashboard from './Dashboard.vue';
import ContentContainer from './ContentContainer.vue';
import { courseRef } from '../db';
export default {
  name: 'main',
  components: { Dashboard, ContentContainer },
  computed: {
    selectedLanguage(){
      return this.$store.state.selectedLanguage;
    },
    selectedCheckpoint() {
      return this.$store.state.selectedCheckpoint
    },
    languages(){
      return  _.map(this.course.checkpoints, (value, key) => key);
    },
    checkpoints(){
      return _.filter(this.course.checkpoints, (val, key) => {
        return key === this.selectedLanguage
      })[0]
    },
    checkpoint(){
      return this.selectedCheckpoint ? this.checkpoints[this.selectedCheckpoint] : false;
    }
  },
  firebase: {
    course: {
      source: courseRef,
      asObject: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main.vue